
import { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import HomeAnimation from '../../components/home-animation/home-animation';
import Questions from '../../components/questions/questions'; // your trivia component
import styles from './Home.module.css';
import Details from '../../components/details/details';

export default function Home() {
  const [stage, setStage] = useState('intro'); // 'intro' | 'questions'
  const [selectedDetails, setSelectedDetails] = useState(null);

  const handleStart = () => {
    setStage('details');
  };

  const handleRestart = () => {
    setStage('intro');
  };

  const handleDetails = (details) => {
    setSelectedDetails(details);
    setStage('questions');
  };

  return (
    <div className={styles.homeWrap}>
      <AnimatePresence mode="wait" >
        {stage === 'intro' && (
          <motion.div
            className={styles.motionDiv}
            key="intro"
            initial={{ opacity: 0, }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0, }}
            transition={{ duration: 0.5, ease: 'easeInOut' }}
          >
            <HomeAnimation onStart={handleStart} />
          </motion.div>
        )}

        {stage === 'details' && (
          <motion.div
            className={styles.motionDiv}
            key="details"
            initial={{ opacity: 0, }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0, }}
            transition={{ duration: 0.5, ease: 'easeInOut' }}
          >
            <Details onSelect={handleDetails}></Details>
          </motion.div>
        )}

        {stage === 'questions' && (
          <motion.div
            className={styles.motionDiv}
            key="questions"
            initial={{ opacity: 0, }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0, }}
            transition={{ duration: 0.5, ease: 'easeInOut' }}
          >
            <Questions onRestart={handleRestart} details={selectedDetails} />
          </motion.div>
        )}


      </AnimatePresence>
    </div>
  );
}
